<template>
    <div class="flex justify-center py-6">
        <div
            :class="{
                'w-full': page && page === 'search',
                'xl:w-96': !page || (page && page !== 'search')
            }"
        >
            <div class="input-group relative flex items-stretch w-full justify-center">
                <div class="border border-solid border-gray-200 rounded-l flex w-full">
                    <span class="input-group-text flex items-center px-3 py-1.5 text-gray-400 w-3 text-base font-normal text-center whitespace-nowrap rounded" id="basic-addon2">
                        <fa-icon :icon="['fas', 'search']" size="xs" />
                    </span>
                    <input
                        v-model="search"
                        id="collection_search"
                        type="search"
                        class="form-control relative flex-auto min-w-0 block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border-none focus:outline-none"
                        placeholder="Search..."
                        aria-label="Search"
                        aria-describedby="button-addon3"
                        @input="inputChange"
                    >
                </div>
                <button class="btn inline-block px-6 py-4 border border-l-0 border-gray-200 text-gray-700 font-medium text-xs leading-tight uppercase rounded-r cursor-pointer" type="button" @click="search = ''">
                    <svg class="w-3 text-gray-400" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M6.7929 7.49998L1.14645 1.85353L1.85356 1.14642L7.50001 6.79287L13.1465 1.14642L13.8536 1.85353L8.20711 7.49998L13.8536 13.1464L13.1465 13.8535L7.50001 8.20708L1.85356 13.8535L1.14645 13.1464L6.7929 7.49998Z"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CollectionSearch',

    props:['page','search_value'],

    data () {
        return {
            search: null
        }
    },

    mounted () {
        if (this.search_value) {
            this.search = this.search_value;
        }
    },

    methods: {
        inputChange (event) {
            this.$emit("search-collection", event.target.value)
        }
    }
}
</script>
